// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oSZs","top":"styles_top__27ip5"};